var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-tips-container"},[_c('van-icon',{staticClass:"error-icon",attrs:{"name":"close"}}),_vm._v(" "),_c('div',{staticClass:"error-text"},[_vm._v(_vm._s(_vm.$lang.askErrorTips))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65bbaa0d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ErrorTips.vue
// module id = null
// module chunks = 